import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Check } from "lucide-react";

export const INCLUSION_TAGS = [
  "Transportation", "Packing Materials", "Loading & Unloading Labour", "Toll Charges", "Fuel Charges",
  "Transit Insurance", "Unpacking", "Handyman Services & Reassembly", "GST",
];

// Lets vendors pick from preset tags AND type freely. Emits a single combined string.
export function InclusionsField({ value = "", onChange, testid = "inclusions" }) {
  const [tags, setTags] = useState([]);
  const [text, setText] = useState("");

  const emit = (nextTags, nextText) => {
    const parts = [...nextTags, ...(nextText.trim() ? [nextText.trim()] : [])];
    onChange(parts.join(", "));
  };
  const toggle = (t) => {
    const next = tags.includes(t) ? tags.filter((x) => x !== t) : [...tags, t];
    setTags(next); emit(next, text);
  };
  const onText = (v) => { setText(v); emit(tags, v); };

  return (
    <div className="space-y-2" data-testid={testid}>
      <Label className="text-xs">What's included in your quote?</Label>
      <div className="flex flex-wrap gap-2">
        {INCLUSION_TAGS.map((t) => {
          const on = tags.includes(t);
          return (
            <button
              type="button" key={t} onClick={() => toggle(t)}
              className={`text-xs px-2.5 py-1.5 border transition-colors flex items-center gap-1 ${on ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border text-muted-foreground hover:border-primary"}`}
              data-testid={`${testid}-tag-${t.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
            >
              {on && <Check className="h-3 w-3" />} {t}
            </button>
          );
        })}
      </div>
      <Textarea
        rows={2} className="rounded-none bg-card text-sm"
        value={text} onChange={(e) => onText(e.target.value)}
        placeholder="Add any other inclusions (e.g. 2 helpers, wrapping, waiting time)…"
        data-testid={`${testid}-text`}
      />
      {value && <p className="text-[11px] text-muted-foreground">Included: <span className="text-foreground">{value}</span></p>}
    </div>
  );
}
